import { gql } from '@apollo/client';
import accessFragment from 'redux/job/queries';

const PROJECTS_QUERY = gql`
  query projects(
    $sortField: String
    $string: String
    $sortDirection: String
    $offset: Int
    $limit: Int
  ) {
    projects(
      sortField: $sortField
      title: $string
      sortDirection: $sortDirection
      offset: $offset
      limit: $limit
    ) {
      count
      project {
        id
        name
        timeCreated
        applicationCount
        accessType
        deleteEligible
        sharedBy {
          email
        }
        access {
          ...Access
        }
        accessAssignedDateTime
        jobs {
          id
          title
          companyDisplayName
          status
          online
          applicationStatusConsent
          datePosted
          expireDate
          dateTimeCreated
          employmentType
          jobEmploymentType {
            category
            name
          }
          application_count
          applicationDeliveryMethod
          accessType
          accessAssignedDateTime
          selectionEnded
          untilFilled
          url
          unread
          siteVisibility
          location
          readableLocation
          duration
          jobType
          cities {
            id
          }
          noResponseCount
          showNoResponse
          respondsToAppsBadgeRate {
            id
            rate
            windowStart
            windowEnd
            assignmentDate
          }
          didYouHireFeedback
          didYouHireFeedbackUrgency
          hiredApplications {
            id
            name
            candidateProfileId
          }
          hiringOutcome {
            action
            answeredAt
            reason
            reasonText
          }
        }
      }
    }
  }
  ${accessFragment}
`;

const CITIES_QUERY = gql`
  query cities {
    lists {
      cities {
        id
        name
      }
    }
  }
`;

const DEACTIVATE_JOB = gql`
  mutation deactivateJob($jobId: Int!) {
    deactivateJob(jobId: $jobId) {
      id
      status
      online
    }
  }
`;

const PROJECT_QUERY = gql`
  query project($id: Int!) {
    project(id: $id) {
      id
      name
      timeCreated
      applicationCount
      accessType
      deleteEligible
      access {
        ...Access
      }
      accessAssignedDateTime
      jobs {
        id
        title
        companyDisplayName
        status
        online
        applicationStatusConsent
        datePosted
        expireDate
        dateTimeCreated
        employmentType
        jobEmploymentType {
          category
          name
        }
        application_count
        applicationDeliveryMethod
        accessType
        accessAssignedDateTime
        selectionEnded
        untilFilled
        url
        unread
        siteVisibility
        location
        readableLocation
        duration
        jobType
        cities {
          id
        }
        noResponseCount
        showNoResponse
        respondsToAppsBadgeRate {
          id
          rate
          windowStart
          windowEnd
          assignmentDate
        }
        didYouHireFeedback
        didYouHireFeedbackUrgency
        hiredApplications {
          id
          name
          candidateProfileId
        }
        hiringOutcome {
          action
          answeredAt
          reason
          reasonText
        }
      }
    }
  }
  ${accessFragment}
`;

const RENAME_PROJECT = gql`
  mutation mutateProject($id: Int!, $name: String!) {
    mutateProject(id: $id, name: $name) {
      id
      name
    }
  }
`;

const DELETE_PROJECT = gql`
  mutation deleteProject($id: Int!) {
    deleteProject(id: $id)
  }
`;

const CHANGE_FOLDER = gql`
  mutation moveJobFromProjectToProject(
    $jobId: Int!
    $fromProjectId: Int!
    $toProjectId: Int
    $projectName: String
  ) {
    moveJobFromProjectToProject(
      jobId: $jobId
      fromProjectId: $fromProjectId
      toProjectId: $toProjectId
      projectName: $projectName
    ) {
      id
    }
  }
`;

export {
  CHANGE_FOLDER,
  CITIES_QUERY,
  DEACTIVATE_JOB,
  DELETE_PROJECT,
  PROJECT_QUERY,
  PROJECTS_QUERY,
  RENAME_PROJECT,
};
